import {
  TIndirectTaxSortDirection,
  TIndirectTaxListTransactionsParams,
} from './types';

export class IndirectTaxTransactionQueryUtils {
  static formatArrayToString(value: string | string[]): string {
    if (Array.isArray(value)) return value.join(',');
    return value;
  }

  static buildQueryParams(
    filters: TIndirectTaxListTransactionsParams['filters'],
    sortState?: TIndirectTaxListTransactionsParams['sortState']
  ): URLSearchParams {
    const query = new URLSearchParams();

    if (filters.corporationId) query.append('corporationId', filters.corporationId.toString());
    if (filters.from_date) query.append('from_date', filters.from_date);
    if (filters.to_date) query.append('to_date', filters.to_date);
    if (filters.reporting_date_override_from_date) query.append('reporting_date_override_from_date', filters.reporting_date_override_from_date);
    if (filters.reporting_date_override_to_date) query.append('reporting_date_override_to_date', filters.reporting_date_override_to_date);
    if (filters.creation_methods) query.append('creation_methods', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.creation_methods));
    if (filters.source_platforms) query.append('source_platforms', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.source_platforms));
    if (filters.destination_countries) query.append('destination_countries', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.destination_countries));
    if (filters.destination_states) query.append('destination_states', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.destination_states));
    if (filters.origin_countries) query.append('origin_countries', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.origin_countries));
    if (filters.statuses) query.append('statuses', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.statuses));
    if (filters.currency) query.append('currency', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.currency));
    if (filters.target_currency) query.append('target_currency', filters.target_currency);
    if (filters.search_term) query.append('search_term', filters.search_term);
    if (filters.type) query.append('type', filters.type);
    if (filters.types?.length) query.append('types', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.types));
    if (filters.marketplaces) query.append('marketplaces', IndirectTaxTransactionQueryUtils.formatArrayToString(filters.marketplaces));

    if (sortState) {
      query.append('sort_by', sortState.id);
      query.append('sort_order', sortState.desc ? TIndirectTaxSortDirection.DESC : TIndirectTaxSortDirection.ASC);
    }

    return query;
  }
}
